// src/components/LanguageSelector/LanguageSelector.js
import React from 'react';
import { useLanguage } from '../../contexts/LanguageContext';

const LanguageSelector = () => {
  // Get the current language and the change function from our context
  const { language, changeLanguage } = useLanguage();

  // Define the available languages
  const languages = [
    { code: 'en', name: 'English' },
    { code: 'de', name: 'Deutsch' },
    { code: 'fr', name: 'Français' },
  ];

  const handleLanguageChange = (event) => {
    const newLanguage = event.target.value;
    changeLanguage(newLanguage);
  };

  return (
    <div className="my-4">
      <select
        value={language}
        onChange={handleLanguageChange}
        className="w-full bg-brand-dark text-gray-200 border border-slate-600 px-3 py-2 focus:outline-none focus:ring-2 focus:ring-orange-500 transition-all"
        aria-label="Select language"
      >
        {languages.map((lang) => (
          <option key={lang.code} value={lang.code}>
            {lang.name}
          </option>
        ))}
      </select>
    </div>
  );
};

export default LanguageSelector;